var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTsunami(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 110",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.2,101.6H98l1.7-9.8v0c0.5,0.8,1.6,1.1,2.5,0.6l3.9-2.2h0c0.5-0.3,0.8-0.8,0.9-1.3c0.1-0.5-0.1-1.1-0.4-1.5L88.3,66.3 c-0.6-0.7-1.6-0.8-2.3-0.4L61.6,79.7c-0.5,0.3-0.8,0.8-0.9,1.3c-0.1,0.5,0.1,1.1,0.4,1.5l3,3.4c0.7,0.7,1.8,0.8,2.6,0.2l-2.2,12.7 c-20.8-6.7-18.2-29.5-5.2-41.5c3.8-3.4,7.7-4.6,10.5-3.3c0.7,0.3,1.4,0.2,2-0.3c0.6-0.5,0.8-1.2,0.6-1.9c-0.1-0.4-2.6-10-10-11.8 c-3.6-0.9-7.6,0.2-12,3.3c2.1-4.1,4.5-8,7-11.8c0.4-0.6,0.4-1.3,0.1-1.9c-0.3-0.6-0.9-1-1.6-1c-45,0-52.7,71.6-53,74.7 c0,0.5,0.1,1,0.5,1.4c0.3,0.4,0.8,0.6,1.4,0.6h100.4h0c1,0,1.8-0.8,1.8-1.9C107,102.5,106.2,101.6,105.2,101.6L105.2,101.6z  M83.2,101.6l1.2-7.2l-4.3-0.7l-1.3,7.8v0c0,0.1,0,0.1,0,0.1h-0.9c-0.8-0.2-2.9,0.2-2.7-0.8l1.6-9.6v0c0.2-1,1.1-1.7,2.2-1.5l8,1.4 c1,0.2,1.7,1.1,1.5,2.1l-1.4,8.4L83.2,101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,23.1c0.8,0,1.7-0.2,2.4-0.5c1.4,0.8,3,1.2,4.6,1.2c1.7,0,3.4-0.5,4.9-1.4c1.6,0.8,3.4,0.9,5,0.2 c1.6-0.6,2.9-1.9,3.5-3.6c0.6-1.6,0.5-3.4-0.4-5c-0.8-1.5-2.3-2.6-4-3c-1.3-3.8-4.9-6.4-8.9-6.4c-4-0.1-7.6,2.4-9.1,6.1 c-2.9,1-4.7,3.9-4.3,7C8,20.8,10.6,23.1,13.7,23.1L13.7,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1,27c-0.8,0.6-1.1,1.7-0.5,2.6l2.3,3.3c0.3,0.4,0.7,0.7,1.2,0.8c0.5,0.1,1,0,1.4-0.3c0.4-0.3,0.7-0.7,0.8-1.2 c0.1-0.5,0-1-0.3-1.4l-2.3-3.3C23.1,26.6,21.9,26.4,21.1,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2,27c-0.8,0.6-1.1,1.7-0.5,2.6l2.3,3.3c0.3,0.4,0.7,0.7,1.2,0.8c0.5,0.1,1,0,1.4-0.3c0.4-0.3,0.7-0.7,0.8-1.2 c0.1-0.5,0-1-0.3-1.4l-2.3-3.3C30.2,26.6,29,26.4,28.2,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3,27c-0.8,0.6-1.1,1.7-0.5,2.6l2.3,3.3c0.3,0.4,0.7,0.7,1.2,0.8c0.5,0.1,1,0,1.4-0.3c0.4-0.3,0.7-0.7,0.8-1.2 c0.1-0.5,0-1-0.3-1.4l-2.3-3.3h0C15.3,26.6,14.1,26.4,13.3,27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsunami);
export default __webpack_public_path__ + "static/media/tsunami.d61749bf3c9ad0e8a75a9d87bf02081c.svg";
export { ForwardRef as ReactComponent };